// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import getJson from '../services/getJson'
import SelectWithMatcher from './controls/SelectWithMatcher'
import type { VkGroup } from './types'

const MembersCount: StyledComponent<Object, any, any> = styled.div`
  background-color: white;
  display: inline-block;
  border: solid 1px #eee;
  padding: 2px 5px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 2px;
`

type VkGroupOption = {|
  ...VkGroup,
  value: number
|}

type Props = {|
  values: Array<VkGroup>,
  loadedGroups: Array<VkGroup>,
  onLoad: (Array<VkGroup>) => void,
  onChange: (Array<VkGroup>) => void
|}

type State = {|
  isLoading: boolean,
  receivedNotReady: boolean
|}

const matcherT = {
  placeholder: 'Например:\n123454321\n78787878\noneretarget\n',
  subtitle: 'Укажите цифровые или текстовые ID сообществ ВКонтакте. Каждое - с новой строки',
  title: 'Групповое добавление сообществ ВКонтакте'
}

const AUDIENCES_GROUPS_PATH = '/audiences/groups'
const AUDIENCES_GROUPS_BY_IDS_PATH = '/audiences/groups_by_ids'
const AJAX_DELAY = 500

export default class VkGroupsSelect extends Component<Props, State> {
  debouncedSearch: any
  searchString: string

  constructor(props: Props) {
    super(props)

    this.debouncedSearch = _.debounce(this.search, AJAX_DELAY)
    this.searchString = ''

    this.state = {
      isLoading: false,
      receivedNotReady: false
    }
  }

  render() {
    return (
      <div className={this.state.receivedNotReady ? 'not-ready' : null}>
        <SelectWithMatcher
          className="t-VkGroupsSelect"
          matcherClassName="t-VkGroupsIdMatcherModal"
          values={this.groupsToOptions(this.props.values)}
          options={this.groupsToOptions(this.props.loadedGroups)}
          isLoading={this.state.isLoading}
          matcherMaxElementsCount={500}
          matcherPlaceholder={matcherT.placeholder}
          matcherRequestPath={AUDIENCES_GROUPS_BY_IDS_PATH}
          matcherSubtitle={matcherT.subtitle}
          matcherTitle={matcherT.title}
          buildUniqOptions={(found, selectValues) => {
            const options = _.map(found, (group) => {
              return {
                id: group.id,
                value: group.id,
                label: group.name,
                members_count: group.members_count,
                short_name: group.screen_name
              }
            })
            return _.filter(options, (o) => {
              return !_.find(selectValues, { id: o.id })
            })
          }}
          matchElements={(found, inputIds) => {
            return _.filter(found, (group) => {
              return _.find(inputIds, (id) => {
                return group['id'].toString() === id || group['screen_name'] === id
              })
            })
          }}
          onComponentValuesChange={(values) => this.props.onChange(this.optionsToGroups(values))}
          onInputChange={(q) => {
            this.searchString = q
            this.debouncedSearch()
          }}
          onParseFromMatcherInput={(input) => {
            return _.reject(input.split(/[ \t\r\n,]/), _.isEmpty)
          }}
          optionRenderer={(option) => this.optionRenderer(option)}
        />
      </div>
    )
  }

  optionRenderer(option: VkGroupOption) {
    return (
      <div>
        <MembersCount>{this.formatMembersCount(option.members_count)}</MembersCount>
        <span> {option.label}</span>
      </div>
    )
  }

  formatMembersCount(count: number) {
    return (
      '👤 ' +
      count
        .toString()
        .split(new RegExp('(?=(?:...)*$)'))
        .join(',')
    )
  }
  search() {
    let input = this.searchString
    if (!input) return
    this.setState({ isLoading: true })
    getJson(AUDIENCES_GROUPS_PATH, { search: input }).then((response) => {
      if (response['ready']) {
        this.props.onLoad(response['groups'])
        this.setState({ isLoading: false, receivedNotReady: false })
      } else {
        this.setState({ receivedNotReady: true })
        this.debouncedSearch()
      }
    })
  }

  groupsToOptions(groups: Array<VkGroup>): Array<VkGroupOption> {
    return _.map(groups, (group) => ({ ...group, value: group.id }))
  }

  optionsToGroups(options: Array<VkGroupOption>): Array<VkGroup> {
    return options.map((option) => {
      return {
        id: option.id,
        label: option.label,
        members_count: option.members_count,
        short_name: option.short_name
      }
    })
  }
}
